import { useState, useEffect } from 'react';
import { newsService } from '../services/apiService';
import NewsList from '../components/NewsList';

const News = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchNews = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await newsService.getAllNews();
      setNewsItems(response || []);
    } catch (err) {
      setError(err.message || 'Failed to fetch news');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading news...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-medium text-gray-800 mb-6">News Management</h2>
      <NewsList newsItems={newsItems} fetchNews={fetchNews} />
    </div>
  );
};

export default News;